import PropTypes from 'prop-types';
import React from 'react';
import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { urlUtils } from 'javascripts/shared/utils/url_utils';

import { ChirpButton } from 'javascripts/components/chirp_button';
import { CoverImage } from 'javascripts/components/cover_image';
import { Modal } from 'javascripts/components/modal';
import { WishlistButton } from 'javascripts/components/wishlist_button';

import styles from 'stylesheets/components/audiobook/expired_promotion_modal.module';

export function ExpiredPromotionModal({ audiobook, isOpen, onRequestClose }) {
  function onDealsClick() {
    bubEvents.track('Expired deal modal', 'Clicked link', {
      label: 'Show me available deals',
    });
  }

  function onWishlistButtonClick() {
    if (_.isNil(audiobook.currentUserWishlistItem)) {
      urlUtils.setPath(audiobook.url);
    } else {
      bubEvents.track('Expired deal modal', 'Clicked button', {
        label: 'See wishlist',
      });
    }
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <div className={styles.expiredPromotionModal}>
        <div className={styles.coverWrapper}>
          <CoverImage
            coverUrl={audiobook.coverUrl}
            bookAuthor={audiobook.displayAuthors}
            bookTitle={audiobook.displayTitle}
            defer={false}
          />
        </div>

        <div className={styles.header}>This deal has expired.</div>
        <div className={styles.subtext}>
          Deals are only available for a limited-time. You can add this book to your wishlist to be notified if a new
          deal becomes available.
        </div>

        <div className={styles.actionButtons}>
          <WishlistButton
            audiobookId={audiobook.id}
            inCart={!_.isNil(audiobook.currentUserShoppingCartItem)}
            inWishlist={!_.isNil(audiobook.currentUserWishlistItem)}
            buttonStyle='modal'
            onClick={onWishlistButtonClick}
            trackingCategory='Expired deal modal'
          />
          <ChirpButton
            displayStyle='bold'
            displayType='link'
            fullWidth
            label='Show me available deals'
            href='/view-all-audiobook-deals'
            onClick={onDealsClick}
          />
        </div>
      </div>
    </Modal>
  );
}

ExpiredPromotionModal.propTypes = {
  audiobook: ChirpPropShapes.audiobook.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};
